export default {
    weddingList: [],
    weddingListCount: 0,
}